import React from 'react';
import ContentSectionComp from '../components/ContentSectionComp/ContentSectionComp';
import Partners from '../components/Partners/Partners';
import HeroSection from '../components/HeroSection/HeroSection';
import Header from '../components/Header/Header'; // Header component
import Navbar from '../components/Navbar/Navbar'; // Navbar component
import Speakers from '../components/Speakers/Speakers';
import Announcements from '../components/Announcements/Announcements';

function HomePage() {
  

  return (
    <div className="home-page">
      {/* Fixed Header and Navbar */}
      <div className="fixed top-0 left-0 w-full z-50">
        <Header />
        <Navbar />
      </div>

      {/* Main Content Container */}
      <div className="h-full  snap-y snap-mandatory "> {/* Increased padding for both header and navbar */}
        {/* HeroSection - Start after Header and Navbar */}
        <section
          className="h-screen snap-start"
        >
          <HeroSection />
        </section>
        <section><Announcements /></section>
        {/* Partners Section */}
        <section className="h-50 snap-start flex items-center justify-center bg-white">
          <Speakers/>
          
        </section>
        <section>
          
          <Partners/>
        </section>
        {/* Content Sections */}

        <section

        >
          <ContentSectionComp

          />
        </section>

      </div>
    </div>
  );
}

export default HomePage;
